



























import { Component, Prop, Vue } from 'vue-property-decorator'

const step = 200

@Component({})
export default class Login extends Vue {
  @Prop({ type: Number, default: 2000 }) readonly delay!: number

  @Prop({ type: String, default: '' }) readonly message!: string

  @Prop({ type: String }) readonly redirectTo!: string

  timer?: any = undefined

  countdown: number = this.delay

  get seconds (): number {
    return parseInt(String((this.countdown + 1000) / 1000), 10)
  }

  get value (): number {
    return parseInt(String((115 / this.delay) * (this.delay - this.countdown)), 10)
  }

  mounted () {
    this.countdown = this.delay
    this.timer = setInterval(() => {
      this.countdown -= step
      if (this.countdown < 0) {
        clearInterval(this.timer)
        this.handleTimeout()
      }
    }, step)
  }

  handleClick () {
    clearInterval(this.timer)
    if (this.$listeners && this.$listeners.click) {
      this.$emit('click')
    } else {
      this.redirect()
    }
  }

  handleTimeout () {
    clearInterval(this.timer)
    if (this.$listeners && this.$listeners.timeout) {
      this.$emit('timeout')
    } else {
      this.redirect()
    }
  }

  redirect () {
    location.href = this.redirectTo || this.$appConfig.homeUrl
  }
}
